type UseIsAnswered<T> = {
  questions: T[];
  answers: PvWizardResultsQueryVariables;
  activeSlide: number;
};

export const useIsAnswered = <T extends { key: keyof PvWizardResultsQueryVariables }>({
  questions,
  answers,
  activeSlide
}: UseIsAnswered<T>) => {
  const activeQuestionKey = questions[activeSlide]?.key;
  return activeQuestionKey && answers[activeQuestionKey] != null;
};
